"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkWrapper = void 0;
const styles_1 = require("@mui/material/styles");
exports.LinkWrapper = (0, styles_1.styled)("div")({
    fontSize: "1rem",
    marginBottom: "20px",
    "&:first-of-type": {
        marginTop: "37px"
    }
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3RhYmxlLW9mLWNvbnRlbnQvc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLGlEQUE4QztBQUVqQyxRQUFBLFdBQVcsR0FBRyxJQUFBLGVBQU0sRUFBQyxLQUFLLENBQUMsQ0FBQztJQUN2QyxRQUFRLEVBQUUsTUFBTTtJQUNoQixZQUFZLEVBQUUsTUFBTTtJQUNwQixpQkFBaUIsRUFBRTtRQUNqQixTQUFTLEVBQUUsTUFBTTtLQUNsQjtDQUNGLENBQUMsQ0FBQyJ9